// Login page //

import React from 'react'
import Login from '../components/Login';
import ScrollToTop from '../components/ScrollToTop';

const LoginPage = () => {
    return (
        <>
            <ScrollToTop/>
            <Login />
        </>
    );
};

export default LoginPage;